<template>
    <div>
        <b-modal
            :hideFooter="true"
            :title="title"
            ref="filesModal"
            size="lg"
        >
            <div class="row">
                <p class="col-sm-3 text-right font-weight-bold">{{ uLang('app.add_new_document') }}</p>
                <file-upload
                    @uploadSuccess="handleUploadSuccess($event)"
                    @uploadFailed="handleUploadFailure($event)"
                    class="col-sm-9"
                />
            </div>
        </b-modal>
        <div class="col-12 list-holder mb-3">
            <a href="#"
                class="btn btn-brand"
                @click.prevent="openModal"
            >{{ uLang('app.add_type', { type: this.uLang('app.documents') }) }}</a>

            <div class="row mt-3">
                <div class="col-xl-4 col-lg-6 col-md-12 mb-3" v-for="file in files">
                    <file-card
                        :file="file"
                        @deleteFile="removeFile"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { FileUpload } from '~/components/tabs/documents'
    import { FileCard } from '~/components/cards'

    export default {
        name: "AddFileModule",

        components: {
            FileUpload,
            FileCard,
        },

        props: {
            title: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                files: [],
            };
        },

        methods: {
            clear() {
                for(file of this.files) {
                    this.removeFile(file);
                }

                this.files = [];
            },

            openModal() {
                this.$refs.filesModal.show();
            },

            async removeFile(file){
                const { data } = await window.axios.delete(route('files.destroy', { file: file.id }))

                this.files = this.files.filter((current_file) => {
                    return data.id != current_file.id;
                });
                this.$emit('filesUpdated', this.files)
            },

            handleUploadSuccess(file) {
                this.files.push(file);
                this.$refs.filesModal.hide();
                this.$emit('filesUpdated', this.files)
                this.$snotify.info(uLang('app.entity_created', { entity: uLang('app.document') }),
                    uLang('app.created'));
            },

            handleUploadFailure(message) {
                if(message.file) {
                    this.$snotify.error(message.file)
                    return
                }
                this.$snotify.error(message)
            },
        }
    }
</script>
<style scoped>

</style>